import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

import { SiteHeader } from "../../components/header/header";
import { useAuthentication } from "../../../services/authentication/authentication.context";
import { FormInput } from "../../components/forms/form-input";
import { isNull } from "../../_helpers/isNull";
import { LoadingIndicator } from "../../components/utils/loader";
import { AppAlert } from "../../components/utils/alert";
import { formatImageUrl } from "../../_helpers/route-image";

export const UpdateAccount = () => {

    const imgBtnRef = useRef();

    const {
        account,
        passwordChange,
        isLoading,
        token,
        updateAccount,
        uploadAvatar,
        removeAvatar
    } = useAuthentication();

    const [accountData, setAccountData] = useState({
        names: '',
        password: '',
        repeatPassword: ''
    });

    const [displayImg, setDisplayImage] = useState("/logos/avatar.png");
    const [showSection, setShowSection] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeat, setShowRepeat] = useState(false);
    const [onAlert, setOnAlert] = useState();
    const [fileData, setFileData] = useState();

    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');

    const handleSubmit = async () => {
        if (isNull(password)) {
            setOnAlert({
                caption: 'Invalid password!',
                message: 'Password cannot be null',
                accept: 'Ok',
                onAccept: () => setOnAlert()
            })
            return;
        }

        if (isNull(repeatPassword) || password !== repeatPassword) {
            setOnAlert({
                caption: 'Password mismatch!',
                message: 'Passwords do not match!',
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });
            return;
        }

        const resp = await passwordChange({ password, repeatPassword }, token);
        if (resp?.error) {
            setOnAlert({
                caption: 'Error!',
                message: resp?.error,
                accept: 'Ok',
                onAccept: () => {
                    setOnAlert();
                }
            });
            return;
        }

        setOnAlert({
            message: resp?.message,
            caption: "Success",
            accept: 'Ok',
            onAccept: () => {
                setOnAlert();
                window.location.reload();
            }
        })
    }

    const handleUpdateAvatar = async () => {
        if (!fileData) {
            setOnAlert({
                caption: 'Error!',
                message: "There is no data for the new image!",
                accept: 'Ok',
                onAccept: () => {
                    setOnAlert();
                }
            });
            return;
        }

        if (account?.avatar) {
            const resp1 = await removeAvatar(account?.avatar);
            if (resp1?.error) {
                setOnAlert({
                    caption: 'Error!',
                    message: 'Failed to delete old avatar',
                    accept: 'Ok',
                    onAccept: () => setOnAlert()
                })
                return;
            }
        }
        const uploadRes = await uploadAvatar(fileData);
        const imgUri = uploadRes?.uri;
        const resp = await updateAccount({ 'avatar': imgUri }, token);
        if (resp?.error) {
            setOnAlert({
                caption: 'Error!',
                message: "Upload failed!",
                accept: 'Ok',
                onAccept: () => {
                    setOnAlert();
                }
            });
            return;
        }

        setOnAlert({
            message: resp?.message,
            caption: "Success",
            accept: 'Ok',
            onAccept: () => {
                setOnAlert();
                window.location.reload();
            }
        })

    }

    return (
        <div className="page-body">
            <SiteHeader pageTitle={'Update account'} />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                    onClose={() => setOnAlert()}
                />
            )}

            <div className="slogan-1 login-cap">Mettre à jour le compte</div>
            <div className="update-form-container form-container">
                <form className="update-form">
                    <div className="avatar-update">
                        <img 
                            src={ account?.avatar ? formatImageUrl(account?.avatar) : displayImg} 
                            alt="" 
                            className="avatar" 
                        />
                        <input
                            type="file"
                            ref={imgBtnRef}
                            className="img-update-btn"
                            onChange={(e) => {
                                setDisplayImage(URL.createObjectURL(e.target.files[0]));
                                setFileData(e.target.files[0]);
                            }}
                        />
                        <button
                            className="camera-button"
                            onClick={(e) => {
                                e.preventDefault();
                                imgBtnRef.current.click();
                            }}
                        >
                            <FontAwesomeIcon icon={faCamera} />
                        </button>
                        <button
                            className="avatar-submit"
                            onClick={(e) => {
                                e.preventDefault();
                                handleUpdateAvatar();
                            }}
                        >
                            Changer photo
                        </button>
                    </div>

                    <div className="password-update-section">
                        <FormInput
                            type={showPassword ? "text" : "password"}
                            formIcon={showPassword ? faEyeSlash : faEye}
                            toggleIcon={(e) => {
                                e.preventDefault();
                                setShowPassword((shown) => (!shown))
                            }}
                            required={true}
                            label={"Mot de passe"}
                            name={"password"}
                            onChange={(e) => {
                                e.preventDefault();
                                setPassword(e.target.value);
                            }}
                            value={password}
                        />
                        <FormInput
                            type={showRepeat ? "text" : "password"}
                            formIcon={showRepeat ? faEyeSlash : faEye}
                            toggleIcon={(e) => {
                                e.preventDefault();
                                setShowRepeat((shown) => (!shown))
                            }}
                            required={true}
                            label={"Confirmer  mot de passe"}
                            name={"repeatPassword"}
                            onChange={(e) => {
                                e.preventDefault();
                                setRepeatPassword(e.target.value);
                            }}
                            value={repeatPassword}
                        />
                        <button
                            className="form-button"
                            onClick={async (e) => {
                                e.preventDefault();
                                await handleSubmit();
                            }}
                        >
                            Changer mot de passe
                        </button>
                    </div>

                </form>
            </div>
        </div>
    );
}